import { mapGetters } from "vuex";
import { getCurrentSubdomain } from "@/common/functions";

export default {
    data() {
        return {
            isCCPA: getCurrentSubdomain() === "www",
            items: [
                {
                    label: "aboutUs",
                    url: "https://www.yourdictionary.com/about.html",
                    routerLink: "/empresa/"
                },
                {
                    label: "contactUs",
                    url: "https://www.yourdictionary.com/about/contact.html",
                    routerLink: "/contacto/"
                },
                {
                    label: "suggestionBox",
                    url:
                        "https://docs.google.com/forms/d/e/1FAIpQLSfEpo88kGuycN6aa-1Fi7AttfGkSgn_QsHZACLfAqjJIbnBJw/viewform"
                },
                {
                    label: "privacyPolicy",
                    url: "https://www.yourdictionary.com/about/privacy.html",
                    routerLink: "/politica-de-privacidad/"
                },
                {
                    label: 'cookieSettings',
                    url: '#',
                    routerLink: null,
                    class: 'ot-sdk-show-settings'
                },
                {
                    label: "termsOfUse",
                    url: "https://www.yourdictionary.com/about/terms-of-use.html",
                    routerLink: "/condiciones-de-uso/"
                },
                {
                    label: "sentenceIndex",
                    routerLink: "/indice"
                }
            ],
            enItems: [],
            esItems: []
        };
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    },
    created() {
        let omitItemForEs = this.items[2];
        let esItems = this.items.filter(item => item !== omitItemForEs);

        let omitItemForEn = this.items[5];
        let enItems = this.items.filter(item => item !== omitItemForEn);

        if (this.currentLanguage === "es") {
            this.items = esItems;
        } else {
            this.items = enItems;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/FooterLinks/FooterLinks.js